import { useAtom } from "jotai";
import React from "react";
import { MdOutlineExpandMore, MdOutlineExpandLess } from "react-icons/md";
import { showTicketDetailsAtom } from "../store";

const TicketDetailsHeading = () => {
  const [show, setShow] = useAtom(showTicketDetailsAtom);
  return (
    <div
      className="td-heading-bx cursor-pointer"
      onClick={() => setShow(!show)}
    >
      <h3>Task Details </h3>
      {!show && <MdOutlineExpandMore size={30} color="#76808b" />}
      {show && <MdOutlineExpandLess size={30} color="#76808b" />}
    </div>
  );
};


export default TicketDetailsHeading;
